













































import Vue from 'vue';
import moment from 'moment';
moment.locale('en-gb');
import { ButtonModel } from '@/types';

export default Vue.extend({
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    caption: {
      type: String
    },
    instruction: {
      type: String
    },
    extendButtonIcon: {
      type: String,
      default: 'lock'
    },
    extendButtonCaption: {
      type: String,
      default: 'Extend'
    },
    expirySecondsLeft: {
      type: Number
    },
    buttons: {
      type: Array
    }
  },
  data() {
    return {
      expiryTime: moment(),
      nowIntervalId: 0,
      now: moment()
    };
  },
  methods: {
    setNowToNow(this: any) {
      this.now = moment();
    },
    extend(this: any) {
      clearInterval(this.nowIntervalId);
      this.$emit('extend');
    },
    buttonClicked(this: any, button: ButtonModel) {
      this.$emit('buttonClicked', button);
    }
  },
  computed: {
    expiresInLessThanTenSeconds(this: any): boolean {
      return this.expirySecondsLeft <= 10;
    },
    expired(this: any): boolean {
      return this.expirySecondsLeft <= 0;
    }
  },
  watch: {
    now(this: any) {
      if (this.showModal && this.expired) {
        clearInterval(this.nowIntervalId);
        this.$emit('expired');
      }
    },
    showModal(this: any) {
      if (this.showModal) {
        this.now = moment();
        this.nowIntervalId = setInterval(this.setNowToNow, 1000);
      }
    }
  },
  beforeDestroy(this: any) {
    clearInterval(this.nowIntervalId);
  }
});
